/*
  The REVIEWS.io "Rating Snippet" app embed scans the DOM once, when its own
  script loads. Product cards that arrive later — AJAX collection filtering,
  load more, search, quick view, cart drawer recommendations — therefore come
  back with an empty .ruk_rating_snippet. This re-runs the app's own renderer
  for those cards.

  It targets .urvi-card-rating rather than .ruk_rating_snippet so the product
  page's snippet, which belongs to the REVIEWS.io app block, is left alone.

  Each element is requested at most once (data-ruk-requested). That matters:
  a product with no reviews renders nothing at all, so "still empty" is not a
  usable retry signal — without the marker the observer below would re-request
  it on every DOM mutation, forever.
*/
(function () {
  var SNIPPET_CLASS = 'urvi-card-rating';
  var OPTIONS = {
    store: 'ur-vi.com',
    color: '#000000',
    linebreak: false,
    text: 'Reviews',
  };

  var scheduled = null;
  var waits = 0;

  function unrequested() {
    var nodes = document.getElementsByClassName(SNIPPET_CLASS);
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.hasAttribute('data-ruk-requested')) continue;
      // Already filled in by the app embed's own initial pass.
      if (node.children.length) continue;
      if (!node.getAttribute('data-sku')) continue;
      out.push(node);
    }
    return out;
  }

  function render() {
    scheduled = null;

    var nodes = unrequested();
    if (!nodes.length) return;

    if (typeof window.ratingSnippet !== 'function') {
      // The embed's script may still be in flight. Give it ~10s, then give up
      // rather than poll for the life of the page.
      if (waits++ < 40) scheduled = window.setTimeout(render, 250);
      return;
    }

    waits = 0;
    for (var i = 0; i < nodes.length; i++) nodes[i].setAttribute('data-ruk-requested', '');
    window.ratingSnippet(SNIPPET_CLASS, OPTIONS);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = window.setTimeout(render, 250);
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule);
})();
